import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SliceActions } from '../types';
import { ERequestApiStatus } from '../../types/appState';
import { IChatProfile, TUserProfileState } from '../../types/chatProfile';

const initialState: TUserProfileState = {};

const userProfileSlice = createSlice({
  name: 'userProfile',
  reducers: {
    setUserProfilePending: (state, action: PayloadAction<{ chatId: string }>) => {
      const { chatId } = action.payload;

      state[chatId] = {
        clientInfo: state[chatId]?.clientInfo ?? null,
        status: ERequestApiStatus.Pending,
      };
    },
    setUserProfileLoaded: (state, action: PayloadAction<{ chatId: string } & IChatProfile>) => {
      const { chatId, clientInfo, status } = action.payload;

      state[chatId] = {
        // Если данных не пришло (ошибка или пустой ответ), оставляем ранее загруженные —
        // после неудачного ретрая показывать всё ещё есть что
        clientInfo: clientInfo ?? state[chatId]?.clientInfo ?? null,
        status,
      };
    },
  },
  initialState,
});

export const userProfileReducer = userProfileSlice.reducer;
export const { setUserProfilePending, setUserProfileLoaded } = userProfileSlice.actions;
export type TUserProfileActions = SliceActions<typeof userProfileSlice.actions>;
